var XPortal = XPortal || {};
XPortal.ToolTips = (function () {
    var self = {
        Init: function (container, opts) {
            opts = $.extend({}, {
                show: function (e) {
                    this.popup.element.addClass('default-tooltip');
                },
                filter: "a.tooltip",
                width: 'auto',
                position: "right",
            }, opts ? opts : {});

            container = container ? container : $(XPortal.Main.DetialFormSelector);
            XPortal.ToolTips.kendoTooltip = container.kendoTooltip(opts).data("kendoTooltip");
            var toolTips = container.find("a.tooltip");
            toolTips.click(false);
        }
    };

    return self;
}());
